import { useState } from "react";
import type { FormEvent } from "react";
import { useAvaliarArtigo, type MinhaAvaliacao } from "../../nucleo/conhecimento";
import { mensagemDoConsole } from "../../nucleo/console";
import { Aviso, Botao, CampoLongo } from "../ui";

/** "Isso ajudou?" — sim ou não, com comentário opcional. Responder de novo corrige a resposta. */
export function AvaliacaoDoArtigo({
  artigoId,
  minha,
}: {
  artigoId: string;
  minha: MinhaAvaliacao | null;
}) {
  const avaliar = useAvaliarArtigo(artigoId);
  const [util, setUtil] = useState<boolean | null>(minha?.util ?? null);
  const [comentario, setComentario] = useState(minha?.comentario ?? "");

  function enviar(evento: FormEvent) {
    evento.preventDefault();
    if (util === null) return;
    avaliar.mutate({ util, comentario: comentario.trim() || null });
  }

  return (
    <form className="avaliacao-do-artigo" onSubmit={enviar} data-testid="avaliacao-do-artigo">
      <h2 className="titulo-secao">Este artigo ajudou?</h2>
      <div className="flex gap-2 mb-3" role="group" aria-label="Este artigo ajudou?">
        <Botao
          type="button"
          variante={util === true ? "solido" : "fantasma"}
          aria-pressed={util === true}
          onClick={() => setUtil(true)}
        >
          Sim, ajudou
        </Botao>
        <Botao
          type="button"
          variante={util === false ? "solido" : "fantasma"}
          aria-pressed={util === false}
          onClick={() => setUtil(false)}
        >
          Não ajudou
        </Botao>
      </div>
      {util !== null ? (
        <CampoLongo
          rotulo={util ? "Quer nos contar mais? (opcional)" : "O que faltou? (opcional)"}
          value={comentario}
          maxLength={1000}
          onChange={(evento) => setComentario(evento.target.value)}
        />
      ) : null}
      {avaliar.isError ? (
        <Aviso tom="erro" className="mb-3">
          {mensagemDoConsole(avaliar.error)}
        </Aviso>
      ) : null}
      {avaliar.isSuccess ? (
        <Aviso tom="sucesso" className="mb-3">
          Obrigado pela sua avaliação. Ela ajuda a equipe a melhorar este artigo.
        </Aviso>
      ) : null}
      <Botao type="submit" disabled={util === null || avaliar.isPending}>
        {avaliar.isPending ? "Enviando…" : minha ? "Atualizar avaliação" : "Enviar avaliação"}
      </Botao>
    </form>
  );
}
